var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFacebookRounded = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 23.9985C18.6272 23.9985 24 18.6262 24 11.9988C24 5.37167 18.6272 -0.000976562 12.0002 -0.000976562C5.37273 -0.000976562 0 5.37167 0 11.9988C0 18.6262 5.37273 23.9985 12.0002 23.9985ZM13.0575 8.05349V9.1903H15.3168L15.1597 10.9165L15.0575 12.0327H12.9477V19.1399H10.1051V12.0327H8.68338V9.1903H10.0931V7.9053C10.0931 6.74232 10.647 4.92563 13.0846 4.92563L15.2806 4.93495V7.37057H13.6861C13.4268 7.37057 13.0575 7.4996 13.0575 8.05349Z",
    fill: "#B0BEC5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookRounded, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/FacebookRounded.4e5ce0ba.svg";
export { ForwardRef as ReactComponent };